
import alphaedge from '../assets/grades/alphaedge.webp'
import exceledge from '../assets/grades/exceledge.webp'
import pinnacleedge from '../assets/grades/pinnacleedge.webp'
import quantam from '../assets/grades/quantam.webp'

import one from '../assets/home/home-7.webp'
import two from '../assets/studentsai.webp'
import three from '../assets/studentsplaying.webp'
import four from '../assets/home/home.webp'
import five from '../assets/five.webp'
import speed from '../assets/home/home-02.webp'

import eight from '../assets/eight.webp'
import abacusmain from '../assets/home/home-04.webp'
import speach from '../assets/home/home-01.webp'
import nine from '../assets/home/home-06.webp'
import empower from '../assets/empowerimpact.webp'
import maths from '../assets/home/home-05.webp'
import vedic from '../assets/home/home-03.webp'

//about 
 import everychild from '../assets/about/everychild.webp'
 import tradition from '../assets/about/tradition.webp'
 import environment from '../assets/about/school_environment_banner.webp'

//admissions 
 import open from '../assets/admissions/open.webp'

 import flexible from '../assets/admissions/flexible.webp'
 import stepone from '../assets/admissions/stepone.webp'

//events 
 import anual from '../assets/events/celebrate.webp'
 import exp from '../assets/events/exbition.webp'
 import achivers from '../assets/events/achievers.webp'

//studentlife 

 import everyday from '../assets/events/everyday.webp'
 import studentlife from '../assets/events/studentlife.webp'
 import neverstop from '../assets/events/neverstop.webp'
 import games from '../assets/events/games.webp'

//stateboard 

import stateboradone from '../assets/stateboard/stateboardone.webp'
import stateboradtwo from '../assets/stateboard/stateboradtwo.webp'
import stateboradthree from '../assets/stateboard/stateboradthree.webp'
import stateboradfour from '../assets/stateboard/stateboradfour.webp'

//pre-primary

import preone from '../assets/preeprimary/preeone.webp'
import pretwo from '../assets/preeprimary/preetwo.webp'
import prethree from '../assets/preeprimary/preethree.webp'
import prefour from '../assets/preeprimary/preefour.webp'

//primary
 import primaryone from '../assets/primary/primaryeone.webp'
 import primarytwo from '../assets/primary/primaryetwo.webp'
 import primarythree from '../assets/primary/primarythree.webp'
 import primaryfour from '../assets/primary/primaryfour.webp'

//midle
 import middleone from '../assets/middle/middleeone.webp'
 import middletwo from '../assets/middle/middleetwo.webp'
 import middlethree from '../assets/middle/middlethree.webp'
 import middlefour from '../assets/middle/middlefour.webp'
//cbse
 import cbseone from '../assets/cbse/cbseeone.webp'
 import cbsetwo from '../assets/cbse/cbseetwo.webp'
 import cbsethree from '../assets/cbse/cbsethree.webp'
 import cbsefour from '../assets/cbse/cbsefour.webp'

//iit
 import iitone from '../assets/iit/iiteone.webp'
 import iittwo from '../assets/iit/iitetwo.webp'
 import iitthree from '../assets/iit/iitthree.webp'
 import iitfour from '../assets/iit/iitfour.webp'
 
 export const iit=[iitone,iittwo,iitthree,iitfour]

 export const cbse=[cbseone,cbsetwo,cbsethree,cbsefour]
 export const middle=[middleone,middletwo,middlethree,middlefour]
 export const prePrimary=[preone,pretwo,prethree,prefour]
 export const Primary=[primaryone,primarytwo,primarythree,primaryfour]
 export const acadmicImages = [
 alphaedge,
 exceledge,
 pinnacleedge,
 quantam
];


export const homeImages = [
    // empower,
  speach,
  speed,
  vedic,
  abacusmain,maths,
  nine,
  four,
   one,
  // two,three,five,eight
];


export const aboutImages = [
  everychild,
  tradition,
  environment
  

];



export const AdmissionsImages = [
  stepone,
 open,
 flexible
];

export const studentLifeImages = [
  everyday, 
  studentlife,
  neverstop,
  games
];


export const eventImages = [
anual,
exp,
achivers
];

export const stateBoardImages=[stateboradtwo,stateboradfour,stateboradone,stateboradthree]